import { Modal } from "../../submodules/rapdv/client/elements/Bootstrap"
import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PageThemeEdit implements ClientPage {

  getPageId = (): string => "theme-edit-page"

  execute = async (): Promise<void> => {
    const modalEl = document.querySelector("[data-theme-upgrade-modal]") as HTMLElement | null
    if (!modalEl) return
    const modal = new Modal(modalEl)
    modal.show()
  }

  onPageClose = (): void => {}
}
